module.exports = __webpack_public_path__ + "media/images/emoticons/secret-954508311bf71d20ac8859327b73a0bd.gif";